<template>
  <div class="block_wrap">
    <div class="snapshots-modal-info">
      <div class="input_wrap">
          <fg-input
              v-model="device_name"
              type="text"
              :label="translate('snapshot.device')"
              :readonly="true"
          />
      </div>

      <div class="input_wrap">
        <fg-input
            v-model="created_at"
            type="text"
            :label="translate('snapshot.ts_create')"
            :readonly="true"
        />
      </div>
    </div>
    <div class="snapshots-modal-info">
      <div class="input_wrap">
        <router-link :to="'/user/' + info.user_login" class="link" @click.native="cancel">
          <fg-input
              v-model="info.user_name"
              type="text"
              :label="translate('snapshot.user_name')"
              :readonly="true"
          />
        </router-link>
      </div>
      <div class="input_wrap">
        <router-link :to="'/client/' + info.order_client_id" class="link" @click.native="cancel">
          <fg-input
              v-model="info.order_client_name"
              type="text"
              :label="translate('snapshot.order_client_name')"
              :readonly="true"
          />
        </router-link>
      </div>
    </div>
    <div class="snapshots-modal-info">
      <div class="input_wrap" style="width: 100%">
        <router-link :to="'/device_list?&group=' + info.group_id" class="link" @click.native="cancel">
          <fg-input
              v-model="info.group_name"
              type="text"
              :label="translate('snapshot.group_name')"
              :readonly="true"
          />
        </router-link>
      </div>
    </div>
    <div class="snapshots-modal-info">
      <div class="input_wrap" style="width: 100%">
        <router-link :to="'/client_order/' + info.order_id" class="link" @click.native="cancel">
          <fg-input
              v-model="info.order_name"
              type="text"
              :label="translate('snapshot.order_id')"
              :readonly="true"
          />
        </router-link>
      </div>
    </div>
    <div class="snapshot_card" v-if="info.description">
      <span class="card_title">
        {{ translate('snapshot.desc') }}
      </span>

      <div class="snapshot_card__content">
        <p>
          {{ info.description }}
        </p>
      </div>
    </div>


  </div>
</template>
<script>

export default {
  name: 'MainInfo',
  components: {
  },
  props: ['info'],

  data () {
    return {
    }
  },
  computed:{
    created_at(){
      return this.get_date(this.info.created_at)
    },
    device_name(){
      return `${this.info.device_name2} (${this.info.device_fid})`
    }
  },
  methods: {
    cancel() {
      this.$emit('close_modal')
    },
  }
}

</script>

<style lang='scss' scoped>
.block_wrap {
  height: 500px;
  overflow-x: auto;
  padding: 2px;
  text-align: left;
  .snapshot_card {
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    margin-bottom: 10px;
    .card_title{
      display: block;
      text-align: center;
      padding: 5px;
      background-color: #efe9e9;
      border-bottom: 1px solid #ccc;
    }
    &__content {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      text-align: center;
    }
  }
  .snapshots-modal-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    text-align: left;
    .input_wrap {
      width: 50%;
      margin: 2.5px;
    }
  }
}

</style>

